import { render, staticRenderFns } from "./CajasToolbar.vue?vue&type=template&id=2ce95dfc&scoped=true&lang=pug"
import script from "./CajasToolbar.vue?vue&type=script&lang=js"
export * from "./CajasToolbar.vue?vue&type=script&lang=js"
import style0 from "./CajasToolbar.vue?vue&type=style&index=0&id=2ce95dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce95dfc",
  null
  
)

export default component.exports